import React, { useState } from 'react';

const InvoiceEditor = ({ invoice, patient, onSave, onCancel }) => {
    const [items, setItems] = useState(Array.isArray(invoice?.items) && invoice.items.length ? invoice.items : [{ description: 'Consultation', quantity: 1, price: 30 }]);
    const [status, setStatus] = useState(invoice?.status || 'unpaid');
    const [paymentMethod, setPaymentMethod] = useState(invoice?.paymentMethod || 'Especes');
    const [insurance, setInsurance] = useState(invoice?.insurance || '');

    const handleItemChange = (index, field, value) => {
        const newItems = [...items];
        // Convertir en nombre si le champ est quantity ou price
        const numericValue = (field === 'quantity' || field === 'price') ? parseFloat(value) : value;
        newItems[index][field] = numericValue;
        setItems(newItems);
    };

    const addItem = () => {
        setItems([...items, { description: '', quantity: 1, price: 0 }]);
    };

    const removeItem = (index) => {
        setItems(items.filter((_, i) => i !== index));
    };

    const calculateTotal = () => {
        return items.reduce((acc, item) => acc + ((Number(item.quantity) || 0) * (Number(item.price) || 0)), 0);
    };

    const handleSave = () => {
        const total = calculateTotal();
        onSave({
            ...invoice,
            patientId: invoice?.patientId ?? patient?.id ?? null,
            items,
            total,
            status,
            currency: invoice?.currency || 'USD',
            paymentMethod,
            insurance
        });
    };

    const styles = {
        container: { padding: 20, maxWidth: 900, margin: '0 auto' },
        itemRow: { display: 'grid', gridTemplateColumns: '2fr 1fr 1fr auto auto', gap: 8, alignItems: 'center', marginBottom: 10 },
        summary: { marginTop: 20, padding: 16, border: '1px solid #ddd', borderRadius: 10, backgroundColor: '#f8fafc' },
        actions: { display: 'flex', gap: 10, marginTop: 16 }
    };

    return (
        <div style={styles.container}>
            <h2>Facture pour {patient?.name || 'Patient'}</h2>
            <p>Date: {invoice?.date ? new Date(invoice.date).toLocaleDateString() : '—'}</p>

            <div>
                {items.map((item, index) => (
                    <div key={index} style={styles.itemRow}>
                        <input type="text" value={item.description} onChange={(e) => handleItemChange(index, 'description', e.target.value)} placeholder="Description" />
                        <input type="number" value={item.quantity} onChange={(e) => handleItemChange(index, 'quantity', e.target.value)} placeholder="Quantité" />
                        <input type="number" value={item.price} onChange={(e) => handleItemChange(index, 'price', e.target.value)} placeholder="Prix Unitaire" />
                        <span>Total: {(item.quantity * item.price).toFixed(2)}</span>
                        <button onClick={() => removeItem(index)}>X</button>
                    </div>
                ))}
                <button onClick={addItem}>Ajouter un article</button>
            </div>

            <div style={styles.summary}>
                <h3>Total: {calculateTotal()} {invoice.currency || 'EUR'}</h3>
                <div>
                    <label>Statut: </label>
                    <select value={status} onChange={(e) => setStatus(e.target.value)}>
                        <option value="unpaid">Non Payée</option>
                        <option value="paid">Payée</option>
                    </select>
                </div>
                <div style={{ marginTop: 10 }}>
                    <label>Mode de paiement: </label>
                    <select value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)}>
                        <option>Especes</option>
                        <option>MonCash</option>
                        <option>NatCash</option>
                        <option>Carte / Stripe</option>
                        <option>PayPal</option>
                        <option>Wise</option>
                        <option>Meru</option>
                        <option>Virement</option>
                        <option>Assurance</option>
                    </select>
                </div>
                <div style={{ marginTop: 10 }}>
                    <label>Assurance / prise en charge: </label>
                    <input type="text" value={insurance} onChange={(e) => setInsurance(e.target.value)} placeholder="Nom de l'assurance ou aucune" />
                </div>
            </div>

            <div style={styles.actions}>
                <button onClick={handleSave}>Enregistrer la Facture</button>
                <button onClick={onCancel}>Annuler</button>
            </div>
        </div>
    );
};

export default InvoiceEditor;
